import { NotifyHelper } from "../../../helpers/toast";
import { eLoaiBangTotNghiepActionsObj } from "../../action-types/category/ILoaiBangTotNghiepActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const loaiBangTotNghiepActions = {
    ...generateActions(eLoaiBangTotNghiepActionsObj, "LOAI_BANG_TOT_NGHIEP"),
    ...generateActionForKey(eLoaiBangTotNghiepActionsObj, "LOAI_BANG_TOT_NGHIEP", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eLoaiBangTotNghiepActionsObj, "LOAI_BANG_TOT_NGHIEP", "DELETE_SUCCESS", () => { NotifyHelper.Success("thành công") }),
    ...generateActionForKey(eLoaiBangTotNghiepActionsObj, "LOAI_BANG_TOT_NGHIEP", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eLoaiBangTotNghiepActionsObj, "LOAI_BANG_TOT_NGHIEP", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}
